import { Dropdown, Menu } from "antd"
import './styles.css'

const menu = ({ menuOptions = [] }) => (
  <Menu items={menuOptions} />
);

const CustomDropdown = ({ menuOptions, children, placement = 'top', arrow = true, className = 'custom-dropdown', overlayClassName = "custom-dropdown-overlay" }) => {
  return (
    <Dropdown arrow={arrow} placement={placement} trigger={['click']} className={className} overlayClassName={overlayClassName} overlay={menu({ menuOptions })}>
      {children}
    </Dropdown>
  )
}

export default CustomDropdown